// extracted by mini-css-extract-plugin
export default {"root":"history-modal_root__cnJMg","table":"history-modal_table__Eat7x","loading":"history-modal_loading__6blaE","placeHolderShimmer":"history-modal_placeHolderShimmer__PqAjA"};